import * as React from 'react';

import Input, { Props as InputProps } from '../../../../Input';
import { useDynamicInputMask } from './hooks';

type Props = InputProps & { dynamicInputMask?: boolean };

const CodeInput: React.FC<Props> = ({ dynamicInputMask = false, ...props }) => {
	const { value: textFieldValue, onChange } = props.TextFieldProps;

	const value = props.value || (textFieldValue as string);
	const inputMaskProps = useDynamicInputMask({ value, onChange, enabled: dynamicInputMask });

	return (
		<Input
			{...props}
			value={inputMaskProps.value}
			TextFieldProps={{ ...props.TextFieldProps, ...inputMaskProps }}
		/>
	);
};

export default CodeInput;
